module.exports = __webpack_public_path__ + "img/business-careers.0c9614e4.jpg";